import React from "react";
import * as echarts from "echarts/core";
// import ReactEcharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import { BarChart } from "echarts/charts";

const Bar = (props) => {
  echarts.use([BarChart]);
  const barData = props.total !== 0 ? (props.data / props.total).toFixed(2) * 100 : 0
  const getOption = {
    grid: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
    },
    xAxis: {
      show: false,
    },
    yAxis: [
      {
        type: "category",
        axisTick: { show: false },
        axisLine: { show: false },
        show: false,
        axisLabel: {
          color: "black",
          fontSize: 14,
          textStyle: {
            color: "#fff",
          },
        },
        max: 10, // 关键：设置y刻度最大值，相当于设置总体行高
        inverse: true,
      },
      {
        type: "category",
        axisTick: { show: false },
        axisLine: { show: false },
        show: false,
        axisLabel: {
          color: "black",
          fontSize: 14,
          textStyle: {
            color: "#fff",
          },
        },
        max: 10, // 关键：设置y刻度最大值，相当于设置总体行高
        inverse: true,
      },
    ],
    series: [
      {
        name: "条",
        type: "bar",
        barWidth: 19,
        data: [barData],
        barCategoryGap: 20,
        itemStyle: {
          // normal: {
            barBorderRadius: 10,
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: "#22b6ed",
              },
              {
                offset: 1,
                color: "#3fE279",
              },
            ]),
          // },
        },
        zlevel: 1,
      },
      {
        name: "进度条背景",
        type: "bar",
        barGap:"-100%",
        barWidth: 19,
        data: [100],
        color: "#2e5384",
        itemStyle: {
          // normal: {
            barBorderRadius: 10,
          // },
        },
      },
    ],
  };
  return (
    <>
      <ReactEChartsCore
        echarts={echarts}
        style={{
          height: "100px",
        }}
        option={getOption}
      />
    </>
  );
};

export default Bar;
